import { Http } from "../../../../Services/http";

const API_ENDPOINT = {
    CREATE_BOX_GROUP: "zone/box/create",
    UPDATE_BOX_GROUP: "zone/box/update?id=",
    GET_ONE_BOX_GROUP: "zone/box_group/get"
}

class GroupService {
    constructor() {
      if (GroupService._instance) {
        return GroupService._instance;
      }
      GroupService._instance = this;
    }
    
    createBox(data) {
      return Http.post(API_ENDPOINT.CREATE_BOX_GROUP, data)
    }

    updateBox(id, data) {
      return Http.post(API_ENDPOINT.UPDATE_BOX_GROUP + id, data)
    }

    getOneBoxGroup(id) {
        return Http.get(`${API_ENDPOINT.GET_ONE_BOX_GROUP}?id=${id}`)
    }
  }
  
  const groupService = new GroupService();
  
  export default groupService;
  